import { Box, FormControl, MenuItem, Select } from "@mui/material";
import { Outlet } from "react-router-dom";
import { useApi } from "../app/hooks";
import { ReactComponent as ArrowIcon } from "../assets/img/arrow.svg";

function SignInLayout() {
  const { data: languages = [] } = useApi("language/list");

  const handleChangeLanguage = (e) => {
    localStorage.setItem("locale", e.target.value);
    window.location.reload();
  };

  return (
    <Box sx={{ height: "100vh", display: "flex", flexDirection: "column" }}>
      <Box
        sx={{
          alignItems: "center",
          paddingInline: { xs: "23px", xls: "50px", height: "89px" },
        }}
        className="sign-in-layout"
      >
        <Box component="div" sx={{ fontSize: "24px", fontWeight: "bold" }}>
          Roomster
        </Box>
        <FormControl>
          <Select
            defaultValue={localStorage.locale}
            sx={{
              background: "white",
              borderRadius: "10px",
              width: 80,
            }}
            MenuProps={{
              PopoverClasses: {
                paper: "hotels_select_body language beauty_scrollbar",
              },
            }}
            IconComponent={ArrowIcon}
            onChange={handleChangeLanguage}
          >
            {languages.map((lang) => (
              <MenuItem key={lang.code} value={lang.code}>
                {lang.code.toUpperCase()}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Box>
      <Box sx={{ background: "#0D8CEB1A", flexGrow: 1 }}>
        <Outlet />
      </Box>
    </Box>
  );
}

export default SignInLayout;
